import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2611c634&scoped=true&lang=css"
script.__scopeId = "data-v-2611c634"

export default script